var map = {
	"./energy.svg": 443,
	"./subsidy.svg": 444,
	"./tax.svg": 445,
	"./tradewar.svg": 446
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 289;



//////////////////
// WEBPACK FOOTER
// ./app/assets/images/icons/events nonrecursive ./~/raw-loader!\.svg$
// module id = 289
// module chunks = 2 5